<script>
  import Section from './Section.svelte';
  import CaptureStore from '../stores/capture.store';
  import {credentials} from '../config.json'
  
  let credentialsName = $CaptureStore.credentialsName || Object.keys(credentials)[0];
  let prevCredentialsName = credentialsName;
  let disabled = true;
  const onApplyAppCredentials = () => {
    $CaptureStore.credentialsName = credentialsName;
    prevCredentialsName = credentialsName;
    disabled = true;
  };
</script>

<h2>Settings</h2>
<Section name="Scope">
  <form on:submit|preventDefault={onApplyAppCredentials}>
    <div class="column">
      <label>Type of Capture Scope
        <select bind:value={credentialsName} on:change={()=>{disabled=prevCredentialsName==credentialsName}}>
          {#each Object.keys(credentials) as name}
            <option value={name}>{credentials[name].label}</option>
          {/each}
        </select>
      </label>
      <label>App ID
        <input bind:value={credentials[credentialsName].appId} readonly>
      </label>
      <label>Developer ID
        <input bind:value={credentials[credentialsName].developerId} readonly>
      </label>
      <label>App Key
        <input bind:value={credentials[credentialsName].appKey} readonly>
      </label>
    </div>
    <div class="column">
      <div class="text">
        {credentials[credentialsName].help.join(' ')}
      </div>
      <div class="bottom-right">
        <button type="submit" disabled={disabled}>Apply</button>
      </div>
    </div>
  </form>
</Section>

<style>
  h2 {
    margin: 10px;
  }

  label {
    display: flex;
    gap: 5px;
    margin: 5px;
    flex-direction: column;
    font-size: 1.2em;
  }
  
  input {
    padding: 5px;
    border: none;
    border-radius: 5px;
    font-size: 1.2em;
  }

  button {
    padding: 10px 30px;
    font-size: 1.2em;
    border-radius: 5px;
  }

  select {
    font-size: 1.2em;
    padding: 5px;
    border-radius: 5px;
  }

  form {
    display: flex;
    gap: 10px;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 5px;
  }

  .bottom-right {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
  }

  .bottom-right button {
    align-self: flex-end;
  }

  .text {
    font-size: large;
  }
	@media  screen and (max-width: 812px) {
		form {
			flex-direction: column;
		}
    .bottom-right {
      position:relative;
    }
    .bottom-right button{
      position:relative;
    }
	}
</style>